/* Shadeday — petits utilitaires partagés (apparition au défilement, prix, défilement vers la fiche). */
(function () {
  var SD = (window.SD = window.SD || {});
  var html = document.documentElement;

  /* ---- Prix : même rendu que le filtre Liquid « money » dans la devise du marché (aucun symbole codé en dur).
     1) échantillon « 123456 | money » rendu par sd-head (ex. « £1,234.56 », « 1.234,56 € », « ¥1,235 ») : on en déduit
        préfixe, suffixe, séparateurs et décimales ; 2) sinon le money_format de la boutique ; 3) sinon Intl avec la devise. */
  function decode(s) {
    try { return new DOMParser().parseFromString(String(s || ''), 'text/html').documentElement.textContent || ''; }
    catch (e) { return String(s || ''); }
  }
  function group(cents, decimals, thousands, decimal) {
    var parts = (Math.round(Number(cents) || 0) / 100).toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  var fromSample = (function () {
    var sample = decode(html.getAttribute('data-sd-money-sample'));
    var m = /\d[\d.,'\s\u00a0\u202f]*\d/.exec(sample);
    if (!m) return null;
    var num = m[0];
    var prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + num.length);
    var decimals = 0, decimal = '.';
    var last = /([.,'\s\u00a0\u202f])(\d+)$/.exec(num);
    if (last && last[2].length === 2) { decimals = 2; decimal = last[1]; num = num.slice(0, -3); }
    var sep = /\D/.exec(num);
    var thousands = sep ? sep[0] : '';
    return function (cents) { return prefix + group(cents, decimals, thousands, decimal) + suffix; };
  })();
  var fromFormat = (function () {
    var fmt = decode(html.getAttribute('data-sd-money'));
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    if (!m) return null;
    return function (cents) {
      var out;
      switch (m[1]) {
        case 'amount_no_decimals': out = group(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = group(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = group(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': out = group(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': out = group(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = group(cents, 0, ' ', ','); break;
        default: out = group(cents, 2, ',', '.');
      }
      return fmt.replace(m[0], out);
    };
  })();
  SD.money = function (cents) {
    if (fromSample) return fromSample(cents);
    if (fromFormat) return fromFormat(cents);
    var currency = html.getAttribute('data-sd-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    try { if (currency) return new Intl.NumberFormat(html.lang || undefined, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100); }
    catch (e) { /* devise inconnue */ }
    return group(cents, 2, ',', '.');
  };

  /* Horizon fait défiler .page-wrapper (et non la fenêtre) à partir de 990 px : renvoie le bon conteneur. */
  SD.scroller = function () {
    var wrap = document.querySelector('.page-wrapper');
    return (wrap && wrap.scrollHeight > wrap.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(wrap).overflowY)) ? wrap : null;
  };

  /* Défilement doux vers un élément, décalé de `offset` px sous le haut de l'écran. */
  SD.scrollToEl = function (el, offset) {
    if (!el) return;
    offset = typeof offset === 'number' ? offset : 100;
    var scroller = SD.scroller();
    if (scroller) {
      scroller.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - offset), behavior: 'smooth' });
    } else {
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset), behavior: 'smooth' });
    }
  };

  SD.scrollToProduct = function (e) {
    var target = document.querySelector('.sd-product [data-sd-atc]') || document.querySelector('.sd-product');
    if (!target) return;
    if (e) e.preventDefault();
    SD.scrollToEl(target, 120);
  };

  function reveal() {
    var els = document.querySelectorAll('.sd-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function links() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#sd-product"], a[href$="#buy"], [data-sd-scroll]');
      if (!a) return;
      if (document.querySelector('.sd-product')) SD.scrollToProduct(e);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(); links(); });
  else { reveal(); links(); }
  document.addEventListener('shopify:section:load', reveal);
})();
